module.exports = "/_next/static/images/4ddc1734237f7796a6a2afb60a3cb0dc-hero-lg.png";